import React, { useState, useContext } from 'react';
import LeadService from "../Lead/Controller/CommunicationController";
import { ThemeContext } from "../Layout/Theme/ThemeContext";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Draggable from 'react-draggable';
import Swal from 'sweetalert2';
import EmailPreviewModal from './EmailPreviewModal';
import SunTextEditor from "./SunTextEditor";
function MultipleEmail({ onClose, ToEmail = [], Module, ModuleID, MultipleIDs }) {
    const { theme } = useContext(ThemeContext);
    const accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        ID: 0,
        vc_Subject: '',
        vc_Description: '',
        vc_From: localStorage.getItem('Email') || '',
        vc_To: ToEmail, // Array of emails
        vc_CC: '',
        Module: Module,
        ModuleID: ModuleID,
        MultipleIDs: MultipleIDs,
        EmailFooter: localStorage.getItem('EmailFooter'),
        DisplayName: localStorage.getItem('DisplayName')
    });
    const [showEmailPreview, setShowEmailPreview] = useState(false);
    const [errors, setErrors] = useState({});
    const [currentEmailInput, setCurrentEmailInput] = useState("");

    const handleFieldChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleEditorChange = (content) => {
        setFormData({
            ...formData,
            vc_Description: content
        });
    };

    /** ✅ Add Email when user presses Enter or comma */
    const handleEmailInputKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ',' || e.key === ';') {
            e.preventDefault();
            const email = currentEmailInput.trim();
            if (email && isValidEmail(email) && !formData.vc_To.includes(email)) {
                const updatedTo = [...formData.vc_To, email];

                setFormData({
                    ...formData,
                    vc_To: updatedTo,
                    vc_CC: updatedTo.length > 1 ? '' : formData.vc_CC // ✅ clear CC
                });

                setCurrentEmailInput("");
            }
        }
    };

    /** ✅ Remove Email by index */
    const handleRemoveEmail = (index) => {
        const updatedEmails = [...formData.vc_To];
        updatedEmails.splice(index, 1);

        setFormData({
            ...formData,
            vc_To: updatedEmails
        });
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        try {

            const errors = {};
            if (!formData.vc_Description || formData.vc_Description.trim() === "") {
                errors.vc_Description = 'Description is required';
            }
            if (!isValidEmail(formData.vc_From)) {
                errors.vc_From = 'Please enter a valid From email';
            }
            if (!formData.vc_To || formData.vc_To.length === 0) {
                errors.vc_To = 'Recipient list cannot be empty';
            } else {
                const invalidEmails = formData.vc_To.filter(email => !isValidEmail(email));
                if (invalidEmails.length > 0) {
                    errors.vc_To = `Invalid emails: ${invalidEmails.join(', ')}`;
                }
            }
            if (formData.vc_CC) {
                const ccEmails = formData.vc_CC.split(/[;,]+/).map(e => e.trim());
                const invalidCC = ccEmails.filter(email => email && !isValidEmail(email));
                if (invalidCC.length > 0) {
                    errors.vc_CC = `Invalid CC emails: ${invalidCC.join(', ')}`;
                }
            }

            setErrors(errors);

            if (Object.keys(errors).length === 0) {
                const postData = {
                    ...formData,
                    vc_To: formData.vc_To.join(';') // send as semicolon separated string
                };
                const response = await LeadService.LeadSendMultipleEmail(postData);
                if (response === "Email send successfully") {
                    localStorage.setItem('HasRecordUpdated', "1");
                    Swal.fire(
                        'Success!',
                        'Email Send Successfully.',
                        'success'
                    );
                    onClose();
                }

            }
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
        finally {
            setLoading(false); // Stop loading after fetching
        }
    };

    const isValidEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const handleStart = (e) => {
        e.stopPropagation();
    };
    const quillModules = {
        toolbar: [
            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
            [{ size: [] }],
            ['bold', 'italic', 'underline'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' },
            { 'indent': '-1' }, { 'indent': '+1' }],
            ['link', 'image'],  // 👈 make sure 'image' is here
            ['clean']
        ]
    };
    return (
        <div>
            {loading && (
                <div class="loading" style={{ zIndex: "10000" }}>
                    <div class="d-table">
                        <div class="d-tablecell">
                            <span class="loader">
                                <span class="loader-inner"></span>
                            </span>
                        </div>
                    </div>
                </div>
            )}
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade customerHistoryModal show d-block" tabIndex="-1" aria-hidden="true" data-backdrop="static">
                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-header" onStart={handleStart}
                            cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p"
                            bounds={{ top: 0, bottom: window.innerHeight - 400 }}>
                            <div className="modal-content">
                                <div className={`modal-header ${accordTheme}`}>
                                    <h5 className="modal-title">Send Email</h5>
                                    <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {/* From */}
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                        <label className="col-sm-2 col-form-label">From</label>
                                        <div className="col-sm-4">
                                            <input type="text" className="form-control" name="vc_From" value={formData.vc_From} disabled />
                                            {errors.vc_From && <div style={{ color: 'red' }}>{errors.vc_From}</div>}
                                        </div>
                                    </div>

                                    {/* ✅ Editable To with removable emails */}
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                        <label className="col-sm-2 col-form-label">To</label>
                                        <div className="col-sm-10">
                                            <div className="form-control email-container">
                                                {formData.vc_To.map((email, index) => (
                                                    <span key={index} style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        margin: '2px',
                                                        padding: '4px 8px',
                                                        background: '#e0e0e0',
                                                        borderRadius: '12px',
                                                        fontSize: '14px'
                                                    }}>
                                                        {email}
                                                        <span
                                                            style={{ marginLeft: '8px', cursor: 'pointer', color: 'red', fontWeight: 'bold' }}
                                                            onClick={() => handleRemoveEmail(index)}
                                                        >
                                                            ×
                                                        </span>
                                                    </span>
                                                ))}
                                                <input
                                                    type="text"
                                                    value={currentEmailInput}
                                                    onChange={(e) => setCurrentEmailInput(e.target.value)}
                                                    onKeyDown={handleEmailInputKeyDown}
                                                    style={{ border: 'none', outline: 'none', flex: 1, minWidth: '120px' }}
                                                />
                                            </div>

                                            {errors.vc_To && <div style={{ color: 'red' }}>{errors.vc_To}</div>}
                                        </div>
                                    </div>

                                    {/* CC */}
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                        <label className="col-sm-2 col-form-label">CC</label>
                                        <div className="col-sm-10">
                                            <input type="text" className="form-control" name="vc_CC" value={formData.vc_CC} onChange={handleFieldChange} disabled={formData.vc_To.length > 1} />
                                            {errors.vc_CC && <div style={{ color: 'red' }}>{errors.vc_CC}</div>}
                                        </div>
                                    </div>

                                    {/* Subject */}
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                        <label className="col-sm-2 col-form-label">Subject:</label>
                                        <div className="col-sm-10">
                                            <input type="text" className="form-control" name="vc_Subject" value={formData.vc_Subject} onChange={handleFieldChange} />
                                            {errors.vc_Subject && <div style={{ color: 'red' }}>{errors.vc_Subject}</div>}
                                        </div>
                                    </div>

                                    {/* Description */}
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                        <label className="col-sm-2 col-form-label">Description:<span style={{ color: "red" }}>*</span></label>
                                        <div className="col-sm-10">
                                            <SunTextEditor
                                                value={formData.vc_Description}
                                                onChange={(content) =>
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        vc_Description: content,
                                                    }))
                                                }
                                                placeholder="Hi #Title# #FirstName# #LastName#,
                                                            Write your email here..."
                                            />
                                            {errors.vc_Description && <div style={{ color: 'red' }}>{errors.vc_Description}</div>}
                                        </div>
                                    </div>
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                        <label htmlFor="vc_Description" className="col-sm-2 col-form-label"><span style={{ "color": "red" }}>*</span></label>
                                        <div className="col-sm-10">
                                            <button type="button" className="btn btn-info" onClick={() => setShowEmailPreview(true)}>
                                                Preview Email
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button type="submit" className="btn btn-primary">
                                        <i class="icofont-send-mail"></i> Send
                                    </button>
                                    <button className="btn btn-danger" type="button" aria-label="Close" onClick={onClose}>
                                        <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                                    </button>
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            </form>
            {(showEmailPreview &&
                <EmailPreviewModal

                    onClose={() => setShowEmailPreview(false)}
                    subject={formData.vc_Subject}
                    description={formData.vc_Description}
                    footer={formData.EmailFooter}
                    to={formData.vc_To}
                    cc={formData.vc_CC}
                />
            )}
        </div>
    );
}

export default MultipleEmail;
